import React from "react";
import { useTheme } from "@mui/material";
import { useGetTotalUserQuery } from "../../services/report.service";
import DonutChartData from "../../components/global/DonutChartData";

interface DonutChartUserProps {
  id?: string;
}

const DonutChartUser: React.FC<DonutChartUserProps> = ({ id }) => {
  const { data, isFetching, isLoading } = useGetTotalUserQuery();
  const theme = useTheme();

  const dataMapper = React.useCallback(
    (data: any, theme: any) => [
      {
        name: "Active",
        value: data?.total_active || 0,
        color: theme.palette.primary.main,
      },
      {
        name: "Not Active",
        value: data?.total_inactive || 0,
        color: theme.palette.grey[500],
      },
      {
        name: "Pending",
        value: data?.total_pending || 0,
        color: theme.palette.secondary.main,
      },
    ],
    []
  );

  return (
    <DonutChartData
      id={id}
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      dataMapper={dataMapper}
    />
  );
};

export default DonutChartUser;
